import { CoreCategoryKey, coreCategoryKeys } from '../../schemas/rewards';

export const abstractCategoryKeys = ['all', 'featured', 'curated', 'exclusive', 'swag'] as const;
export const categoryKeys = [...abstractCategoryKeys, ...coreCategoryKeys] as const;

export type AbstractCategoryKey = (typeof abstractCategoryKeys)[number];

export type CategoryKey = AbstractCategoryKey | CoreCategoryKey;
